<template>
    <div v-if="optionType===1" class='option_item' @click='onClick'>
        <span v-if='icon' class='option_item_icon'>
            <i :class='icon'></i>
        </span>
        <span class='option_item_text' v-html='name.replace(" ","<br>")'></span>
    </div>
    <el-col v-else-if="optionType===2" :span="6" :offset="offset">
      <div class="option-item-flexbox">
        <div :class="[{active: id===activatedId}, 'option_item', 'option_item-small']" @click='onClick'>
            <span class="option_item_icon">
                <i :class="icon"></i>
            </span>
            <span class="option_item_text" v-html='name'></span>
        </div>
        <div v-if="suggestion">
          <div class=suggestion>
            <slot name="suggestion"></slot>
          </div>
        </div>
      </div>
    </el-col>
</template>

<script>
import HpcSuggestion from '@/views/HpcSuggestion'
export default {
  name: 'OptionItem',
  components: { HpcSuggestion },
  props: {
    icon: {
      type: String
    },
    name: {
      type: String
    },
    index: {
      type: Number
    },
    id: {
      type: Number
    },
    optionType: {
      type: Number
    },
    activatedId: {
      type: Number
    },
    spanProp: {
      type: Number,
      default: 6
    },
    suggestion: {
      type: String
    }
  },
  computed: {
    offset () {
      if (this.name === '男性' || this.name === '年齡性別') {
        return 3
      }
      return 0
    }
  },
  methods: {
    onClick () {
      this.$emit('change', this.index)
    }
  }
}
</script>

<style scoped>
  .option-item-flexbox {
    display: flex;
    flex-direction: column;
  }
  .suggestion {
    height: 40px;
    font-size: 14px;
    line-height: 1.5;
    color: #9b9b9b;
    padding: 0 8px;
  }
</style>
